import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { TrailGroups } from '../components/TrailGroups';
import { UpcomingAdventures } from '../components/UpcomingAdventures';
import { JoinSection } from '../components/JoinSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen w-full bg-earth-50" data-id="element-138">
      <Hero data-id="element-139" />
      <About data-id="element-140" />
      <TrailGroups data-id="element-141" />
      <UpcomingAdventures data-id="element-142" />
      <JoinSection data-id="element-143" />
      <Footer data-id="element-144" />
    </main>;
}